
  import { Component, Watch, Vue }              from 'vue-property-decorator';
  import { Action, Getter }                     from 'vuex-class';
  import   ChatView                             from './views/chat/ChatView.vue';
  import   ChatroomView                         from './views/chatroom/ChatroomView.vue';
  import { EventBus,
           WidgetConfigEntity,
           ResponsiveUiHelper,
           ConfigService,
           ConfigThemeService,
           BotInitializationService }           from '.';
  import { ClickTrackingService } from './data-access/widget/services/ClickTrackingService';
  @Component({
    name: 'App',
    components: {
      ChatView,
      ChatroomView,
    }
  })
  export default class App extends Vue {
    @Action('getConversationSessionId', { namespace: 'conversationSession' }) getConversationSessionId: any;
    @Action('retrieveWidgetConfigParameters', { namespace: 'conversationSession' }) retrieveWidgetConfigParameters: any;
    @Action('setFullscreenState', { namespace: 'widget' }) setFullscreenState: any;

    @Getter('currentSessionId', { namespace: 'conversationSession' }) currentSessionId!: string | undefined;
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;
    @Getter('isWidgetConfigAvailable', { namespace: 'conversationSession' }) isWidgetConfigAvailable!: string | undefined;
    
    isFullscreenDisplay: boolean = false;
    isChatroom!: boolean;

    get injectionElemId() {
      return ConfigService.getIntegrationTagId();
    }

    get botSettingsLanguage() {
      return window.botSettings.lang || 'fr';
    }

    created() {
      // check the bootstraping mode
      this.isChatroom = (!window.botSettings || !window.botSettings.faqId);

      // Set if we are in fullscreen or not
      this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify);
      EventBus.$emit('ON_RESIZE_SCREEN_MODE', this.isFullscreenDisplay);

      if (!window.botSettings) { 
        // create the object that will be used by the application
        window.botSettings = {};

      } else if (window.botSettings.faqId && window.botSettings.botKey && window.botSettings.synapseBotId) {
        window.botSettings.lang = window.botSettings.lang || 'fr';
        ConfigService.setBotCredentials(window.botSettings.faqId, 
                                        window.botSettings.botKey, 
                                        window.botSettings.synapseBotId,
                                        window.botSettings.lang);
        this.initClickTracking(window.botSettings.faqId);
      }

      if (window.botSettings && window.botSettings.faqId && !this.isWidgetConfigAvailable) {
        this.retrieveWidgetConfigParameters();
      }

      EventBus.$on('ADMIN_INIT_READY_EVENT', () => {
        this.retrieveWidgetConfigParameters();
      });

      
      
      BotInitializationService.addStyleRuleInDOM('.' + ConfigService.getElementClassOrIdToHideInFullScreenModePrefixed(),"display: none !important");
      BotInitializationService.addStyleRuleInDOM('.' + ConfigService.getSynapseClassToHideScrollbar(),"overflow: hidden !important");
    }
    
    mounted() {
      // Adding event listeners for keyboard navigation
      document.body.addEventListener('keydown', this.handleTabPress);
      document.body.addEventListener('mousedown', this.handleMouseDown);
    }

    beforeDestroy() {
      // Removing event listeners for keyboard navigation
      document.body.removeEventListener('keydown', this.handleTabPress);
      document.body.removeEventListener('mousedown', this.handleMouseDown);
    }

    // When navigating with tab, add a class to the body to show focus
    handleTabPress(e: KeyboardEvent) {
      if (e.key === 'Tab') {
        document.body.classList.add('keyboard-navigation');
      }
    }

    // When navigating with mouse, remove the class to hide focus
    handleMouseDown() {
      document.body.classList.remove('keyboard-navigation');
    }
    
    destroyed() {
      EventBus.$off('ADMIN_INIT_READY_EVENT');
    }

    @Watch('isWidgetConfigAvailable')
    onWidgetConfigAvailableEvent() {
      ResponsiveUiHelper.initializeBreakpoints(this.$vuetify);
      ConfigThemeService.initializeThemeVariables(this.$vuetify);
      
      const customCssFile: string | null = ConfigService.getCustomCSSFile();
      if (customCssFile) {
        let linkCssPreloadTag: HTMLLinkElement = document.createElement('link');
        linkCssPreloadTag.setAttribute('rel', 'preload');
        linkCssPreloadTag.setAttribute('href', customCssFile);
        linkCssPreloadTag.setAttribute('as', 'script');
        
        let linkCssTag: HTMLLinkElement = document.createElement('link');
        linkCssTag.setAttribute('href', customCssFile);
        linkCssTag.setAttribute('rel', 'stylesheet');

        let headElem: HTMLHeadElement = document.getElementsByTagName('head')[0];
        headElem.appendChild(linkCssPreloadTag);
        headElem.appendChild(linkCssTag);
      }

      // Retrieve conversation session 
      const widgetConfig: WidgetConfigEntity | undefined = ConfigService.widgetConfig;
      if (widgetConfig) {
        let isRefresh = false
        this.getConversationSessionId({ widgetConfig , isRefresh }); 
      }

      this.$vuetify.theme.dark = (ConfigThemeService.getDefaultTheme() === 'dark');
    }

    onResizeScreen() {
      if(ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify) != this.isFullscreenDisplay){
        this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify);
        EventBus.$emit('ON_RESIZE_SCREEN_MODE', this.isFullscreenDisplay);
      }
    }

    initClickTracking(faqId: any) {
      console.log("init click tracking")
      document.addEventListener('click', (event: Event) => {
          const target = event.target as HTMLElement;
          const link = target.closest('a[data-answer-id]') as HTMLAnchorElement;
          console.log("clicked detected")
          if (link) {
              const answerId = link.getAttribute('data-answer-id');
              if (answerId) {
                  // ✅ Fire the backend call when the user clicks a citation
                  ClickTrackingService.registerCitationClick(answerId);
              }
          }
      });
    }
  }
